import * as amplitude from '@amplitude/analytics-browser'
import { EventName, EventProperties } from '../models/analyticsModels'
import { v4 as uuidv4 } from 'uuid'
import { isString } from 'lodash'

const ANON_ID_KEY = 'amplitude_anon_id'

const getOrCreateAnonId = (): string => {
    if (typeof window === 'undefined') return ''

    let anonId = localStorage.getItem(ANON_ID_KEY)
    if (!anonId) {
        anonId = uuidv4()
        localStorage.setItem(ANON_ID_KEY, anonId)
    }
    return anonId
}

const getIsProd = () => {
    const key = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY as string
    const isProd = process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' && isString(key)
    return isProd
}

let isInitialized = false

export const initAnalytics = () => {
    const isProd = getIsProd()

    if (isInitialized || !isProd) {
        if (!isProd) {
            console.info('[Amplitude] Skipped initialization (non-production environment)')
        }
        return
    }

    amplitude.init(process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY as string, {
        defaultTracking: {
            pageViews: false,
            sessions: true
        }
    })

    setUserContext(getOrCreateAnonId())

    isInitialized = true
}

export const setUserContext = (userId: string) => {
    const isProd = getIsProd()

    if (!isProd) {
        console.info('[Amplitude] setUserContext', { userId })
        return
    }

    if (!userId) {
        const anonId = getOrCreateAnonId()
        amplitude.setUserId(anonId)
        return
    }

    amplitude.setUserId(userId)
}

export const clearUserContext = () => {
    const isProd = getIsProd()

    if (!isProd) {
        console.info('[Amplitude] clearUserContext')
        return
    }

    amplitude.reset()
}

export function trackEvent<T extends EventName>(eventName: T, properties?: EventProperties<T>): void {
    const isProd = getIsProd()

    if (!isProd) {
        console.info('[Amplitude] trackEvent', eventName, properties)
        return
    }

    amplitude.track(eventName, properties)
}
